var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Easing, Tween } from "@tweenjs/tween.js";
var CorePanel = /** @class */ (function (_super) {
    __extends(CorePanel, _super);
    function CorePanel(scene, x, y) {
        var _this = _super.call(this, scene, x, y) || this;
        _this.scene.add.existing(_this);
        return _this;
    }
    CorePanel.prototype.destroy = function (fromScene) {
        var _this = this;
        var onHide = function () {
            _super.prototype.destroy.call(_this, fromScene);
        };
        this.hide(onHide);
    };
    CorePanel.prototype.hide = function (onHide, ms) {
        var _this = this;
        if (ms === void 0) { ms = 500; }
        this.setVisible(true);
        var v = { alpha: 1 };
        new Tween(v)
            .to({ alpha: 0 }, ms)
            .easing(Easing.Circular.Out)
            .onUpdate(function (_a) {
            var alpha = _a.alpha;
            _this.setAlpha(alpha);
        })
            .onComplete(function () {
            _this.setVisible(false);
            onHide === null || onHide === void 0 ? void 0 : onHide();
        })
            .start();
    };
    CorePanel.prototype.resize = function (width, height) {
        var w = Math.min(width * this.RESIZE_W_FACTOR, this.RESIZE_W_MAX);
        var h = Math.min(height * this.RESIZE_H_FACTOR, this.RESIZE_H_MAX);
        var s_x = w / this.RESIZE_W_MAX;
        var s_y = h / this.RESIZE_H_MAX;
        var s = Math.min(s_x, s_y);
        this.setScale(s);
    };
    return CorePanel;
}(Phaser.GameObjects.Container));
export default CorePanel;
